import { useQuery } from '@tanstack/react-query';

import { fetchCarrierInfo } from '../../data-provider/select-options';

export const useGetCarrierInfo = (carrierKey: number | undefined) => {
  return useQuery({
    enabled: Boolean(carrierKey),
    queryFn: () => fetchCarrierInfo({ CarrierKey: Number(carrierKey) }),
    queryKey: ['claims-loss-and-damage-carrier-info', carrierKey],
  });
};
